<template>
  <div class="row">
    <div class="col">
      <div class="titre">Consultation société</div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div v-if="isDataLoading == true" class="row">
        <div class="col">
          <vue-loaders  name="ball-beat" ></vue-loaders>
        </div>
      </div>
      <div v-else class="row">
        <div class="col">
          <div class="row">
            <div class="col lbl">
              <label>No de fiche :</label>
            </div>
            <div class="col txt">
              <p v-if="!numeroFiche"> ... </p>
              <p v-else> {{ numeroFiche }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Nom :</label>
            </div>
            <div class="col txt">
              <p v-if="!nom"> ... </p>
              <p v-else> {{ nom }} </p>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col lbl">
              <label>Classe :</label>
            </div>
        <div class="col txt">
          <p v-if="!classeAfficher"> ... </p>
          <p v-else> {{ classeAfficher }} </p>
        </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Raison d'être :</label>
            </div>
            <div class="col txt">
              <p v-if="!raisonEtre"> ... </p>
              <p v-else> {{ raisonEtre }} </p>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-7 lbl">
              <label>Mineur (Sévérité inv. autres) : </label>
            </div>
            <div class="col-5 txt">
              <div v-if="this.mineureInvestigationLectureColonne || this.mineureInvestigationEcritureColonne">
                <div v-bind:class="obtenirCouleur(mineureInvestigation)">
                  <p v-if="!mineureInvestigationAfficher"> ... </p>
                  <p v-else> {{ mineureInvestigationAfficher }} </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-7 lbl">
              <label>Majeur (Sévérité inv. SQ/RACJ) :</label>
            </div>
            <div class="col-5 txt">
              <div v-if="this.majeureInvestigationLectureColonne || this.majeureInvestigationEcritureColonne">
                <div v-bind:class="obtenirCouleur(majeureInvestigation)">
                  <p v-if="!majeureInvestigationAfficher"> ... </p>
                  <p v-else> {{ majeureInvestigationAfficher }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationBasic',
  props: ['isDataLoading', 'numeroFiche', 'nom', 'classeAfficher', 'raisonEtre', 'majeureInvestigationLectureColonne',
  'majeureInvestigationEcritureColonne', 'mineureInvestigationLectureColonne', 'mineureInvestigationEcritureColonne', 
  'mineureInvestigation', 'majeureInvestigation', 'mineureInvestigationAfficher', 'majeureInvestigationAfficher'],
  methods: {
    obtenirCouleur(cle) {
      return "severite" + cle;
    }
  }
}
</script>